import ConsultingForm from '../ConsultingForm/ConsultingForm';

const Consultinencey = (props) => {
    return (
        <section className={`wpo-contact-section-s2 section-padding ${props.cnClass}`}>
            <div className="container">
                <div className="wpo-contact-section-wrapper">
                    <div className="row justify-content-center">
                        <div className="col col-xl-5 col-lg-6">
                            <div className="contact-info-wrap">
                                <div className="contact-info-title">
                                    <h3>Contact Info</h3>
                                    <p>Get in touch with us for consultations, legal guidance, or any questions you may have. Our team is ready to assist you promptly and professionally.</p>
                                </div>
                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <i className="fi flaticon-001-house"></i>
                                    </div>
                                    <div className="contact-info-text">
                                        <h4>Office Address</h4>
                                        <p>38 Northampton Crescent, Eastlea, Harare </p>
                                    </div>
                                </div>
                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <i className="fi flaticon-002-open"></i>
                                    </div>
                                    <div className="contact-info-text">
                                        <h4>Email Address</h4>
                                        <p>Info@wtafirm.co.zw</p>
                                    </div>
                                </div>
                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <i className="fi flaticon-003-headphone"></i>
                                    </div>
                                    <div className="contact-info-text">
                                        <h4>Phone</h4>
                                        <p>+263 789 099 315 / +263 716 501 140</p>
                                    </div>
                                </div>
                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <i className="fi flaticon-004-clock"></i>
                                    </div>
                                    <div className="contact-info-text">
                                        <h4>Office Hour</h4>
                                        <p>Mon-Fri: 8am – 4.30pm</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col col-xl-5 col-lg-6 col-md-12 col-12">
                            <div className="wpo-contact-form-area">
                                <div className="form-title">
                                    <span>Contact Us</span>
                                    <h3>Free Consulting</h3>
                                </div>
                                <ConsultingForm/>
                                <div style={{ marginBottom: '6rem' }}>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Consultinencey;